import maplibregl from 'maplibre-gl';
import BaseProduct from './BaseProduct';
import LayerManager from './LayerManager';
import store, { getLayerOpacity } from '../state';
import ManifestTimelineHelper from '../services/ManifestTimelineHelper';
import { getTileUrl, getModelCoordinates } from '../config';

export class DarkskiesLayer extends BaseProduct {
  public readonly id = 'darkskies';
  private lastModel: string = '';
  private lastTimeMs: number = 0;
  private lastOpacity: number = 1.0;

  constructor(map: maplibregl.Map, layerManager: LayerManager) {
    super(map, layerManager);

    store.subscribe((state) => {
      const isDarkskiesActive = state.primaryProduct === 'darkskies' ||
        (state.activeLayerProducts && (state.activeLayerProducts['darkskies_bortle'] === true || state.activeLayerProducts['darkskies'] === true));

      if (!isDarkskiesActive) {
        if (this.active) {
          this.deactivate();
        }
        return;
      }

      if (!this.active) {
        this.active = true;
      }

      const selectedModel = state.selectedModels[this.id] || 'blend';
      const model = (selectedModel === 'bortle' || !selectedModel) ? 'blend' : selectedModel;
      const current = state.currentTimeStep || ManifestTimelineHelper.getNowDate(state.timelineRange);
      const timeMs = current ? current.getTime() : 0;
      const opacity = getLayerOpacity(this.id, 1.0);

      if (model !== this.lastModel || timeMs !== this.lastTimeMs || opacity !== this.lastOpacity) {
        this.lastModel = model;
        this.lastTimeMs = timeMs;
        this.lastOpacity = opacity;
        this.refresh();
      }
    });
  }

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.lastModel = '';
    this.lastTimeMs = 0;
    this.layerManager.removeBufferedRasterLayer(this.id);
    this.layerManager.removeLayer(this.id);
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const selectedModel = state.selectedModels[this.id] || 'blend';
    const model = (selectedModel === 'bortle' || !selectedModel) ? 'blend' : selectedModel;
    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : (state.currentTimeStep || ManifestTimelineHelper.getNowDate(state.timelineRange));
    if (!current) return;

    const ok = this.updateStandardInterpolatedRaster({
      layerId: this.id,
      product: this.id,
      model,
      targetTime: current,
      opacity,
      minzoom: 0,
      maxzoom: 5
    });
    if (!ok) {
      const d = typeof current === 'number' ? new Date(current) : current;
      const dateStr = d.toISOString().split('T')[0];
      const hourStr = String(d.getUTCHours()).padStart(2, '0');
      const tiles = [getTileUrl(manifest, this.id, model, dateStr, hourStr)];
      this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5, 'linear', getModelCoordinates(manifest, this.id, model));
    }
  }
}
export default DarkskiesLayer;

